import React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { hasTrussDesignPermission } from '@paragon/login-tools';

import { SelectableItemType } from '../../../../library/selection/types';
import { useAppMonitor } from '../../../../monitor';
import { handleStandardSceneItemRightClick } from '../../../../store/actions/sceneInteractionActions';
import { inViewOnlyMode } from '../../../../store/selectors/viewOnlyModeSelectors';
import { isRightClickableItemType } from '../../../../store/slices/viewportSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';

export function PropertiesPanelMenuButton(props: { type: SelectableItemType; guid: string }) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const { type, guid } = props;

  const viewOnly = useAppSelector(inViewOnlyMode);
  const hasPermission = useAppSelector(hasTrussDesignPermission);
  const supportsContextMenu = isRightClickableItemType(type);

  if (viewOnly || !hasPermission || !supportsContextMenu || type === 'referenceLine') return null;

  return (
    <IconButton
      onClick={(event) => {
        monitor.recordInteraction('Properties panel menu opened', { type });
        dispatch(handleStandardSceneItemRightClick(event, { type, guid, origin: 'dom' }));
      }}
    >
      <MoreVertIcon />
    </IconButton>
  );
}
